// New grouped sidebar for Tier 4 (Executive / CEO / Admin).
// Each group is collapsible; expansion state persisted to localStorage per user.
// Tiers 1-3 keep their right-sized flat sidebars from sidebar_tiers.js — unaffected.

export const TIER_4_GROUPED_SIDEBAR = [
  {
    id: "overview",
    label: "Overview",
    items: [
      { to: "/dashboard",     label: "Dashboard",  icon: "House" },
      { to: "/cases/tracker", label: "Tracker",    icon: "Pulse" },
      { to: "/analytics",     label: "Analytics",  icon: "ChartLine" },
    ],
  },
  {
    id: "cases",
    label: "Cases",
    items: [
      { to: "/cases",                          label: "All Cases",     icon: "FolderOpen" },
      { to: "/cases/nfor",                     label: "+ New NFOR",    icon: "FilePlus" },
      { to: "/escalations",                    label: "Escalations",   icon: "Warning" },
      { to: "/cases?type=Counterfeit",         label: "Counterfeit",   icon: "Stamp",     childOf: "Cases · By type" },
      { to: "/cases?type=Diversion",           label: "Diversion",     icon: "Stamp",     childOf: "Cases · By type" },
      { to: "/cases?type=Tampering",           label: "Tampering",     icon: "Stamp",     childOf: "Cases · By type" },
      { to: "/cases?type=Infringement",        label: "Infringement",  icon: "Stamp",     childOf: "Cases · By type" },
    ],
  },
  {
    id: "intelligence",
    label: "Intelligence",
    items: [
      { to: "/intelligence",      label: "IntelliProbe v3.0", icon: "Lightning", badge: "AI" },
      { to: "/reports/sighting",  label: "Sightings",         icon: "Eye" },
      { to: "/leads",             label: "Leads",             icon: "Lightning" },
      { to: "/products",          label: "Suspect Products",  icon: "Cube" },
      { to: "/parties",           label: "Suspect Parties",   icon: "UserCircle" },
      { to: "/network",           label: "Network Graph",     icon: "Globe" },
      { to: "/map",               label: "Map",               icon: "MapPinLine" },
      { to: "/products/registry", label: "Product Registry",  icon: "ShieldCheck" },
    ],
  },
  {
    id: "channel",
    label: "Channel Manager",
    items: [
      { to: "/channel/dashboard", label: "Channel Dashboard", icon: "ChatCircle", badge: "NEW" },
      { to: "/channel/inbox",     label: "Unified Inbox",     icon: "ChatText" },
      { to: "/channel/leads",     label: "Leads Pipeline",    icon: "Funnel" },
      { to: "/channel/flows",     label: "Flow Builder",      icon: "Path" },
    ],
  },
  {
    id: "hr",
    label: "HR",
    items: [
      { to: "/hr/leave",            label: "My Leave",           icon: "Calendar", badge: "NEW" },
      { to: "/hr/leave/approvals",  label: "Leave Approvals",    icon: "CheckSquare" },
    ],
  },
  {
    id: "field",
    label: "Field Operations",
    items: [
      { to: "/field-ops", label: "Field Ops",      icon: "MapTrifold" },
      { to: "/capture",   label: "Capture",        icon: "Camera" },
      { to: "/whatsapp",  label: "WhatsApp",       icon: "WhatsappLogo" },
    ],
  },
  {
    id: "reports",
    label: "Reports",
    items: [
      { to: "/reports?mode=online",      label: "Online (OSINT)",   icon: "ChartBar" },
      { to: "/reports?mode=offline",     label: "Offline (Field)",  icon: "ChartBar" },
      { to: "/reports?mode=integrated",  label: "Integrated",       icon: "ChartBar" },
    ],
  },
  {
    id: "commercial",
    label: "Commercial",
    items: [
      { to: "/clients",           label: "Clients",          icon: "Buildings" },
      { to: "/contractors",       label: "Suppliers",        icon: "Briefcase" },
      { to: "/quality",           label: "Quality",          icon: "ShieldCheck" },
      { to: "/gov-verify",        label: "Gov Verify",       icon: "Stamp" },
      { to: "/legal-templates",   label: "Legal Templates",  icon: "FilePlus" },
      { to: "/tap2verify",        label: "Tap2Verify",       icon: "Pulse" },
    ],
  },
  {
    id: "finance",
    label: "Finance",
    items: [
      { to: "/finance/dashboard", label: "Finance Dashboard", icon: "ChartLine", badge: "NEW" },
      { to: "/invoices",        label: "Invoices",      icon: "Receipt" },
      { to: "/payables",        label: "Payables",      icon: "CurrencyInr" },
      { to: "/receivables",     label: "Receivables",   icon: "Receipt" },
      { to: "/billing",         label: "Billing",       icon: "CreditCard" },
      { to: "/reports",         label: "Reports & Exports", icon: "ChartBar" },
    ],
  },
  {
    id: "admin",
    label: "Administration",
    items: [
      { to: "/settings/team", label: "Team Directory", icon: "Users" },
      { to: "/stakeholders",  label: "Stakeholder Directory", icon: "Buildings", badge: "NEW" },
      { to: "/org",           label: "Org Chart",      icon: "Tree" },
      { to: "/audit",         label: "Audit Log",      icon: "ChartBar" },
      { to: "/settings",      label: "Settings",       icon: "Gear" },
      { to: "/developer",     label: "Developer",      icon: "Code" },
      { to: "/webhooks",      label: "Webhooks",       icon: "Lightning" },
      { to: "/admin/build-status", label: "Build Status", icon: "Pulse" },
    ],
  },
  {
    id: "governance",
    label: "Governance",
    items: [
      { to: "/approvals",              label: "Approvals",      icon: "CheckSquare", badge: "NEW" },
      { to: "/recycle-bin",            label: "Recycle Bin",    icon: "TrashSimple", badge: "NEW" },
      { to: "/settings/custom-fields", label: "Custom Fields",  icon: "SlidersHorizontal", badge: "NEW" },
      { to: "/settings/admin/feature-toggles", label: "Feature Toggles", icon: "Toggle", badge: "NEW" },
      { to: "/settings/admin/departments", label: "Departments", icon: "Buildings", badge: "NEW" },
      { to: "/settings/admin/lifecycles", label: "Case Lifecycles", icon: "TreeStructure", badge: "NEW" },
      { to: "/settings/admin/branding", label: "Branding", icon: "Palette", badge: "NEW" },
      { to: "/admin/people", label: "People Admin", icon: "UsersThree", badge: "NEW" },
      { to: "/settings/admin/invite-user", label: "Invite User", icon: "UserPlus" },
      { to: "/settings/profile", label: "My Profile", icon: "User" },
      { to: "/admin", label: "Command Center", icon: "ShieldCheck", badge: "CEO" },
      { to: "/admin/audit-trail", label: "Audit Trail", icon: "ChartBar", badge: "CEO" },
      { to: "/admin/bulk-reassign", label: "Bulk Reassign Reports", icon: "UsersThree", badge: "NEW" },
      { to: "/admin/onboarding", label: "Onboarding Email Blast", icon: "PaperPlaneTilt", badge: "CEO" },
      { to: "/stakeholders/drip", label: "Drip Campaigns", icon: "PaperPlaneTilt", badge: "NEW" },
    ],
  },
];

const LS_KEY = "span_sidebar_groups_open_v2";  // bumped for Phase 28-30 (HR, Channel Manager, IntelliProbe)

export function getInitialGroupState() {
  // Auto-expand any group that contains a NEW/AI/CEO badge so newly-shipped features are discoverable
  const autoExpand = {};
  TIER_4_GROUPED_SIDEBAR.forEach(g => {
    if ((g.items || []).some(it => it.badge)) autoExpand[g.id] = true;
  });
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (raw) {
      const saved = JSON.parse(raw);
      // Merge — saved state wins, but groups with badges that aren't explicitly closed get auto-expanded
      return { ...autoExpand, ...saved };
    }
  } catch { /* ignore */ }
  // First-load default: Overview + Cases + every group with a NEW/AI/CEO badge expanded
  return { overview: true, cases: true, ...autoExpand };
}

export function persistGroupState(state) {
  try { localStorage.setItem(LS_KEY, JSON.stringify(state)); } catch { /* ignore */ }
}
